export default "__VITE_ASSET__DtfCSTan__"